import { initDraftFromDrawdown } from "../../draft";
import { Sequence } from "../../sequence";
import { getOpParamValById, flattenParamVals } from "../../operations";
import { NumParam, OperationInlet, OpParamVal, Operation, OpMeta } from "../types";
import { structureOp } from "../categories";
import { defaults } from "../../utils";

const name = "tabby";


const meta: OpMeta = {
  displayname: 'tabby',
  desc: 'Also known as plain weave. Plain weave is one of the most basic weave structures in which each weft thread passes over one warp end and under one warp end; the next weft pick follows the pattern on the alternate warp threads (over/under/over/under). Tabby variations include basket weave, rib weave, and rep weave. These derivatives can be generated by modifying the parameters',
  img: 'tabby.png',
  categories: [structureOp],
  old_names: ['tabbyder']
}



//PARAMS
const warps_raised: NumParam =
{
  name: 'warps raised',
  type: 'number',
  min: 0,
  max: 5000,
  value: 1,
  dx: ""
};

const warps_lowered: NumParam =
{
  name: 'warps lowered',
  type: 'number',
  min: 0,
  max: 5000,
  value: 1,
  dx: ""
}

const base_pics: NumParam =
{
  name: 'base pics',
  type: 'number',
  min: 0,
  max: 5000,
  value: 1,
  dx: 'the number of pics upon which the first tabby pic will be repeated'
};

const alt_pics: NumParam =
{
  name: 'alt pics',
  type: 'number',
  min: 0,
  max: 5000,
  value: 1,
  dx: 'the number of pics upon which the repeat the alteranting pattern'
};

const params = [warps_raised, warps_lowered, base_pics, alt_pics];

//INLETS

const inlets: Array<OperationInlet> = [];



const perform = (param_vals: Array<OpParamVal>) => {

  const raised: number = <number>getOpParamValById(0, param_vals);
  const lowered: number = <number>getOpParamValById(1, param_vals);
  const rep: number = <number>getOpParamValById(2, param_vals);
  const alt_rep: number = <number>getOpParamValById(3, param_vals);


  const first_row = new Sequence.OneD();
  for (let j = 0; j < raised; j++) {
    first_row.push(1);
  }

  for (let j = 0; j < lowered; j++) {
    first_row.push(0);
  }


  const pattern = new Sequence.TwoD();
  for (let i = 0; i < rep; i++) {
    pattern.pushWeftSequence(first_row.val());
  }

  const inverted = first_row.invert().val();

  for (let i = 0; i < alt_rep; i++) {
    pattern.pushWeftSequence(inverted);
  }

  const draft = initDraftFromDrawdown(pattern.export())
  return Promise.resolve([{ draft }]);

}


const generateName = (param_vals: Array<OpParamVal>): string => {
  return 'tabby(' + flattenParamVals(param_vals) + ')';
}

const sizeCheck = (param_vals: Array<OpParamVal>): boolean => {
  const raised: number = <number>getOpParamValById(0, param_vals);
  const lowered: number = <number>getOpParamValById(1, param_vals);
  const rep: number = <number>getOpParamValById(2, param_vals);
  const alt_rep: number = <number>getOpParamValById(3, param_vals);

  const width = raised + lowered;
  const height = rep + alt_rep;

  return (width * height <= defaults.max_area) ? true : false;
}

export const tabby: Operation = { name, meta, params, inlets, perform, generateName, sizeCheck };



